import { render, staticRenderFns } from "./CompaniesTable.vue?vue&type=template&id=19e2d6c1&scoped=true&"
import script from "./CompaniesTable.vue?vue&type=script&lang=ts&"
export * from "./CompaniesTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e2d6c1",
  null
  
)

export default component.exports